import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper, Button, TextField, Typography,
} from '@material-ui/core';
import { I18n } from 'react-redux-i18n';
import { WorkflowGetListIncomplete, WorkflowCreate, WorkflowDelete } from '../../../redux/actions/tracker/workflowActions';
import { getAuthUser } from '../../../redux/actions/authActions';
import ModalCreateStep from './ModalCreateStep';
import MsTable from '../../table/MsTable';
import { createWokFlowStep } from '../../../redux/actions/tracker/workflowstepActions';
import PageBase from '../../../app/PageBase';
import globalStyles from '../../../styles';

const styles = {
  paper: {
    width: '50%',
  },
};


class WorkFlowCreate extends Component {

  constructor(props) {

    super(props);

    this.state = {
      workflow: null,
      workflowId: '',
      workflowAlreadyCreated: false,
      companyId: 0,
      holdingId: 0,
      userId: 0,
      open: false,
      selectedValue: '',
      wfname: '',
      response: [],
      workflowEditing: 0,
    };

  }


  static propTypes = {
    data: PropTypes.any,
  };


  handleClickOpen = () => {

    this.setState({ open: true });

    const user = getAuthUser();
    const params = this.state;

    const payload = {
      CompanyId: user.context.idCompany,
      Name: params.wfname,
    };


    this.setState({ wfname: '' });

    WorkflowCreate(payload).then(() => {

      const holdingID = this.props.user.context.idHolding;

      WorkflowGetListIncomplete(holdingID).then((response) => {

        const workflowIdlast = response.length - 1;
        this.setState({ response, workflowEditing: response[workflowIdlast].workFlowId });

      });

    }, (e) => {

      alert('falha');

    });

  };

  handleEditOpen = (wf) => {

    this.setState({ open: true, workflow: wf, workflowEditing: wf.workFlowId });

  };


  handleClose = (StepList) => {

    const wfCreate = {
      WorkFlowId: this.state.workflowEditing,
      Steps: StepList,
    };

    if (StepList.length > 0) createWokFlowStep(wfCreate).then(() => {

      alert('Criado com Sucesso');
      this.props.history.push('/workflow/list');

    }, (e) => {

      alert('Erro');

    });

    this.setState({ open: false });

  };

  handleChange = name => (event) => {

    this.setState({
      [name]: event.target.value,
    });

  };

  componentWillMount() {

    const holdingID = this.props.user.context.idHolding;

    WorkflowGetListIncomplete(holdingID).then((response) => {

      this.setState({ response });

    });

  }


  handleDeleteClick(e) {

    const holdingID = this.props.user.context.idHolding;
    const workflowid = e.workFlowId;

    WorkflowDelete(workflowid).then(() => {

      WorkflowGetListIncomplete(holdingID).then((response) => {

        this.setState({ response, data: null });

      });

    }, (e) => {

      alert('Erro ao deletar');

    });

  }

  handleOpen = () => {

    this.setState({ open: true });

  };

  render() {

    const { response, open, wfname, workflow } = this.state;

    return (
      <div>
        <PageBase title={I18n.t('titles.new_workflow')}>
          <TextField
            id="wfname"
            label={I18n.t('fields.workflow_name')}
            value={wfname}
            style={globalStyles.textField}
            onChange={this.handleChange('wfname')}
            margin="normal"
            autoComplete="true"
            onKeyPress={(event) => {

              if (event.key === 'Enter') this.handleClickOpen();

            }}

          />
          <Button onClick={this.handleClickOpen} color="primary" variant="contained" style={{ marginLeft: 50 }}>
            {I18n.t('button.create')}
          </Button>

          {response.length > 0 && (
          <PageBase title={I18n.t('titles.uncompleted_workflow')}>
            <MsTable
              data={response}
              entryKey="workFlowId"
              paginate
              onPaginate={this.onPaginate}
              toolbar
              multiSelectable
              handleEditClick={this.handleEditOpen}
              handleDeleteClick={this.handleDeleteClick.bind(this)}
              clearSelectionAfterDelete
              renderCreateButton={false}
              tableDef={[
                { name: 'workFlowId', label: 'ID' },
                { name: 'name', label: I18n.t('fields.name') },
                { name: 'companyName', label: I18n.t('fields.company') },
              ]}
            />
          </PageBase>
          )
        }

          <ModalCreateStep
            open={open}
            workflow={workflow}
            onClose={StepList => this.handleClose(StepList)}
          />
        </PageBase>
      </div>
    );

  }

k

}

export default withRouter(WorkFlowCreate);



// WEBPACK FOOTER //
// ./src/components/tracker/WorkFlow/WorkFlowCreate.js